var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkArabicLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 40,
    viewBox: "0 0 103 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m92.343 25.98-4.744 11.168-1.073 2.52h.005c1.932.388 3.922.391 5.914.005a13.942 13.942 0 0 0 4.228-1.828c.16-.106.315-.213.47-.323l-4.8-11.542z",
    fill: "#73B158"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.54 30.882z",
    fill: "#7CBC56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m82.096 12.656.026 10.122v.002l4.972 1.558 5.25 1.641-10.248-13.323z",
    fill: "#226188"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m82.122 22.78 4.972 1.558-4.972-1.558zM82.092 12.656h.004v-.002h-.004v.002z",
    fill: "#7CBC56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.642.183a12.938 12.938 0 0 0-7.526 4.192c-.223.253-.443.52-.65.793l-.065.09c-.04.054-.076.109-.115.162l10.809 7.235L79.642.183z",
    fill: "#29A5BA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m61.14 28.656 10.625-2.675-9.003-5.053c-1.675 3.07-1.822 5.856-1.623 7.728z",
    fill: "#73B158"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m94.6 17.318.002.004-.003-.004z",
    fill: "#7CBC56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m61.144 28.717.012.106.023.129c.678 4.017 2.795 6.473 4.255 7.735l6.333-10.706-10.627 2.674c0 .02.004.042.004.062z",
    fill: "#68A855"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.874 37.05a.744.744 0 0 1 .074.059l.06.045c2.14 1.605 4.199 2.637 7.825 2.83a13.11 13.11 0 0 0 1.739-.031c-.971-3.592-3.648-13.462-3.806-13.969v-.003l-6.333 10.707c.155.134.302.254.44.362z",
    fill: "#5B9E54"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m75.572 39.952.004.002.154-.014.1-.01.133-.014c2.246-.264 4.075-1.052 5.292-1.578.291-.126.548-.237.761-.32-2.47-1.51-4.447-3.381-5.977-5.193v-.002a28.044 28.044 0 0 1-1.924-2.557 28.675 28.675 0 0 1-1.195-1.943c-.232-.412-.44-.78-.587-1.106-.567-1.23-.561-1.216-.567-1.236",
    fill: "#5A9252"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.352 2.445A12.852 12.852 0 0 0 85.443.522a9.453 9.453 0 0 0-3.17-.513L82.21.008a12.635 12.635 0 0 0-2.446.154l-.121.021 2.449 12.472 7.432-10.08c-.057-.044-.112-.088-.172-.13z",
    fill: "#1E98B0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.33 9.665a13.074 13.074 0 0 0-4.806-7.09l-7.432 10.08h.004L94.342 9.71l-.012-.046z",
    fill: "#218DA5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.835 14.45c0 .054-.003.11-.003.166 0-.059.003-.113.003-.166zM82.122 22.778a2.248 2.248 0 0 0-.05.017l.05-.015v-.002z",
    fill: "#7CBC56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m82.122 22.78-.05.015c-.007.001-.01.003 0 0-.521.156-.636.193-10.306 3.186l20.577-.001-5.249-1.642-4.972-1.558z",
    fill: "#95C65B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m82.073 22.795.05-.015-.05.015z",
    fill: "#7CBC56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m68.867 15.099-.03.014c-2.568 1.313-4.642 3.23-5.849 5.415l-.016.03c-.072.123-.142.248-.21.372l9.004 5.05-2.9-10.881z",
    fill: "#83BD5C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.095 12.654 71.285 5.42a13.092 13.092 0 0 0-2.454 7.124c0 .012-.067.981.032 2.54 0 .006 0 .009.004.014.266-.133.532-.261.794-.374v-.007.007a24.76 24.76 0 0 1 6.04-1.751c.729-.113 1.463-.197 2.196-.256 1.434-.115 2.891-.088 4.198-.06v-.002z",
    fill: "#25B3C4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m82.122 22.778-.026-10.12-10.33 13.323c9.67-2.993 9.785-3.032 10.306-3.186a.305.305 0 0 1 .05-.017z",
    fill: "#9EC95B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m82.122 22.778-.026-10.122v.001l.026 10.12z",
    fill: "#7CBC56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m71.766 25.98 10.326-13.323v-.001c-1.303-.029-2.76-.055-4.195.06-.732.059-1.466.143-2.196.256a24.765 24.765 0 0 0-6.04 1.751v-.007.007c-.262.113-.528.24-.794.374h-.003l.003.002 2.899 10.882z",
    fill: "#91C45A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.728 29.674zM72.92 28.323zM73.216 28.838zM72.333 27.217zM72.333 27.217c-.377-.751-.557-1.213-.567-1.23.01.017.19.479.567 1.23z",
    fill: "#7CBC56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.343 25.98c-1.26.508-2.531 1.029-3.797 1.553a791.855 791.855 0 0 0-9.497 4.006c-.627.266-1.25.532-1.87.8-.004 0-.007 0-.01.002l-1.13.484c1.53 1.812 3.506 3.682 5.978 5.194 1.003.592 2.31 1.082 4.204 1.579l.118.031.01.002.177.036c.027.005-.025-.005 0 0l1.073-2.52 4.744-11.167z",
    fill: "#83BD5C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.83 29.928z",
    fill: "#7CBC56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.766 25.98v.006c.01.02.19.48.567 1.232.157.319.355.693.587 1.105a29.223 29.223 0 0 0 3.119 4.5l1.13-.482.01-.003a1808.115 1808.115 0 0 1 5.652-2.41c1.9-.804 3.81-1.607 5.715-2.395a420.521 420.521 0 0 1 3.797-1.553H71.766z",
    fill: "#91C45A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.733 11.956a13.288 13.288 0 0 0-.364-2.142l-.028-.102-12.246 2.942v.002L94.6 17.318l.002.003c.027-.26.053-.5.083-.742.065-.529.125-1.365.147-1.963l.003-.166c.02-.867-.017-1.703-.1-2.494z",
    fill: "#20839F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.469 26.165a14.552 14.552 0 0 0-.714-3.547l-9.413 3.362 9.74 4.182c.243-1.002.509-2.418.387-3.997z",
    fill: "#5B9E54"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m102.082 30.162-9.74-4.182 4.797 11.539c3.414-2.452 4.494-5.757 4.506-5.793.133-.43.237-.8.329-1.15h.003l.034-.135c.006-.026.015-.054.022-.08l.003-.017c.013-.06.03-.12.046-.182z",
    fill: "#68A855"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m82.096 12.656 10.247 13.323c.013-.027 1.254-2.215 2.256-8.66l-12.503-4.663z",
    fill: "#267491"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.689 22.423c-1.185-3.233-3.392-5.363-5.01-6.482a12.191 12.191 0 0 0-1.857-1.062l.009-.263a26.328 26.328 0 0 1-.147 1.963c-.03.243-.06.481-.085.741-1.003 6.444-2.243 8.633-2.256 8.66l9.412-3.362c-.023-.064-.043-.13-.066-.195z",
    fill: "#5A9252"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.166 19.956h-2.973a3.123 3.123 0 0 1-2.233-.936 3.177 3.177 0 0 1-.925-2.252c0-.85.33-1.65.927-2.252a3.125 3.125 0 0 1 2.233-.934h2.974l-.003 6.374zm16.712-9.41h-9.79c.01.351.056 1.06.266 1.715.283.88.751 1.326 1.393 1.326l8.13.003c.842 0 1.636.332 2.233.935a3.18 3.18 0 0 1 .926 2.253c0 .85-.33 1.65-.928 2.253a3.128 3.128 0 0 1-2.232.933h-.001l-13.699-.006.004-9.412H27.195c-3.402 0-6.17 2.79-6.171 6.22-.001 3.432 2.766 6.224 6.168 6.225l2.973.001v.813c0 1.405-1.136 2.549-2.53 2.549h-4.442c-1.541 0-1.662 1.992-1.662 2.603v.497h6.104c3.054 0 5.539-2.533 5.54-5.648v-.813l.414.001L46.873 23h.003c3.401 0 6.17-2.79 6.17-6.22.002-3.437-2.765-6.233-6.168-6.234z",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.953 29.454h.427c.264 0 2.583-.048 2.583-1.74v-1.839h-3.01v3.58zM15.431 12.226v17.228h.428c.606 0 2.583-.12 2.583-1.675V10.546h-.428c-.606 0-2.583.121-2.583 1.68zM9.839 12.226V23.23c0 1.757-1.417 3.188-3.16 3.188a3.124 3.124 0 0 1-2.233-.933 3.177 3.177 0 0 1-.928-2.253l-.002-1.6C3.515 20.08 1.537 19.959.93 19.959H.5v3.276c.001 3.43 2.773 6.22 6.179 6.22h.002c3.402-.002 6.17-2.794 6.168-6.225V10.546h-.428c-.606 0-2.582.122-2.582 1.68z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkArabicLogo);
export default __webpack_public_path__ + "static/media/darkArabicLogo.fa552d1354b897997f34f42d9c5d2ae2.svg";
export { ForwardRef as ReactComponent };